export default __webpack_public_path__ + "static/media/Description.1e6c1bf4.svg";